import { Carriers } from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const MarkAsFulfilledDataSchema = z.object({
  fulfillmentGroupId: z.string(),
  shipDate: z.date().nullish(),
  shippingSelection: createEnum(Carriers).nullish(),
  trackingNumber: z.string().nullish(),
  notifyMarketplace: z.boolean(),
  notifyCustomer: z.boolean(),
});

export type MarkAsFulfilledWithDataInput = z.infer<
  typeof MarkAsFulfilledDataSchema
>[];

export const markAsFulfilledWithData = {
  name: "markAsFulfilledWithData" as const,
  input: z.array(MarkAsFulfilledDataSchema),
  output: z.object({ success: z.boolean() }),
};
